<mat-checkbox (change)="$event ? toggleAll($event) : null" [checked]="isChecked()" [indeterminate]="isIndeterminate()"
			  color="primary">
	Toggle All
</mat-checkbox>
